const gamesFa = {
  gameCryptoWar: "Crypto Wars",
  gameSoccer: "Soccer",
};

export default gamesFa;
